export const environment = {
  production: false,
   apiUrl: 'https://crm-api.redmonkwellness.com'
  //apiUrl: 'https://localhost:44398/'
};
